/*
  Input Text
*/

import React from "react";

// Antd
import { Form, InputNumber } from "antd";

// Helpers
import { DIGITS_VALIDATOR } from "@Vytelle/admin/src/constants/Patterns";

// Localization
import LOCALIZATION from "services/LocalizationService";

function Number({
  name,
  label,
  placeholder,
  defaultValue,
  precision,
  onChange,
  disabled,
  required,
  min,
  max,
  step,
  validateTrigger,
  validator,
  onblur,
  readOnly,
  id,
  addonAfter,
  formatter,
  parser,
  dataTestingId,
  tabindex
}) {
  // Rules
  let rules = [
    { required: required, message: LOCALIZATION.REQUIRED },
    {
      pattern: DIGITS_VALIDATOR,
      message: LOCALIZATION.DIGITS_VALIDATION,
    },
  ];

  // Custom Validations
  !!validator && rules.push({ validator });

  return (
    <Form.Item
      name={name}
      label={label}
      validateTrigger={validateTrigger || "onBlur"}
      rules={rules}
    >
      <InputNumber
        placeholder={placeholder || label}
        onChange={onChange || null}
        defaultValue={defaultValue}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        precision={precision}
        onBlur={onblur}
        readOnly={readOnly}
        id={id}
        addonAfter={addonAfter}
        formatter={formatter}
        parser={parser}
        data-testid={dataTestingId}
        tabIndex={tabindex}
        autoFocus={ tabindex === 1 }
      />
    </Form.Item>
  );
}

export default Number;
